import * as styles from './styles.module.css';

export default function Spinner({ size = 50, color = '#017aff' }) {
  return (
    <div
      className={styles.spinner}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderTopColor: color,
      }}
      data-testid="spinner"
    />
  );
}
